/*
  Generic live character counter.

  Attach to any input/textarea that already carries a native `maxlength`:

    <textarea
      maxlength="150"
      data-char-counter
      data-char-counter-template="[count] / [max]"
      data-char-counter-limit-text="Character limit reached"
      data-char-counter-warn="130"            (optional, defaults to max - 20)
      aria-describedby="my-field-counter"
    ></textarea>

    <div id="my-field-counter" class="char-counter" data-char-counter-output>
      <span class="char-counter__message" role="status" data-char-counter-message></span>
      <span class="char-counter__count" aria-hidden="true" data-char-counter-count>0 / 150</span>
    </div>

  `maxlength` is the single source of truth for the cap, so the counter and the
  browser's own hard stop can never disagree.
*/
(function () {
  if (window.__characterCounter) return;
  window.__characterCounter = true;

  var FIELD_SELECTOR = '[data-char-counter]';
  var OUTPUT_SELECTOR = '[data-char-counter-output]';
  var WRAPPER_SELECTOR = '.cart__widget__content__inner, .bb-note';
  var WARN_OFFSET = 20;

  /*
    Find the output relative to the field, never by ID.

    `snippets/cart-block-gift-note.liquid` hardcodes id="gift-note", and that
    snippet is rendered by both the cart page section and the global cart
    drawer -- so /cart really does contain two fields with the same ID. An ID
    lookup would return the first one and drive the wrong counter.
  */
  function findOutput(field) {
    if (field.parentElement) {
      var sibling = field.parentElement.querySelector(OUTPUT_SELECTOR);
      if (sibling) return sibling;
    }

    // Deliberately bounded: an unbounded walk up the tree could reach a
    // sibling field's counter and drive the wrong one.
    var wrapper = field.closest(WRAPPER_SELECTOR);
    return wrapper ? wrapper.querySelector(OUTPUT_SELECTOR) : null;
  }

  function getMax(field) {
    var max = parseInt(field.getAttribute('maxlength'), 10);
    return max > 0 ? max : 0;
  }

  function getWarnAt(field, max) {
    var warn = parseInt(field.getAttribute('data-char-counter-warn'), 10);
    if (warn > 0) return warn;
    return Math.max(0, max - WARN_OFFSET);
  }

  function render(field) {
    var max = getMax(field);
    if (!max) return;

    var output = findOutput(field);
    if (!output) return;

    var count = field.value.length;
    var warnAt = getWarnAt(field, max);
    var atLimit = count >= max;

    var countNode = output.querySelector('[data-char-counter-count]');
    if (countNode) {
      var template = field.getAttribute('data-char-counter-template') || '[count] / [max]';
      countNode.textContent = template.replace('[count]', count).replace('[max]', max);
    }

    /*
      Only the message is a live region, and it only changes when crossing the
      limit -- announcing the running count on every keystroke would be
      unusable with a screen reader.
    */
    var messageNode = output.querySelector('[data-char-counter-message]');
    if (messageNode) {
      var message = atLimit ? field.getAttribute('data-char-counter-limit-text') || '' : '';
      if (messageNode.textContent !== message) {
        messageNode.textContent = message;
      }
    }

    output.classList.toggle('is-warning', !atLimit && count >= warnAt);
    output.classList.toggle('is-at-limit', atLimit);
  }

  function renderAll() {
    Array.prototype.forEach.call(document.querySelectorAll(FIELD_SELECTOR), render);
  }

  /*
    Delegated so counters keep working after the cart drawer re-renders its
    markup, with no re-initialisation needed.
  */
  document.addEventListener('input', function (event) {
    var field = event.target;
    if (field && field.matches && field.matches(FIELD_SELECTOR)) {
      render(field);
    }
  });

  // Values swapped in by a section re-render never fire `input`.
  document.addEventListener('theme:cart:update', renderAll);
  document.addEventListener('theme:cart:load', renderAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }
})();
